/**
 * Portal Manta · extrairKpisDoPortalV26
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';

function extrairKpisDoPortalV26(obj){
  const out = { _formato:'portal-v26', _origem:['Formato nativo do portal v26'] };
  if (obj.qual){
    Object.assign(out, obj.qual);
    out._origem.push(`Qualitativos importados (${Object.keys(obj.qual).length} campos)`);
  }
  if (obj.kpis){
    Object.assign(out, obj.kpis);
    out._origem.push(`KPIs físicos importados (${Object.keys(obj.kpis).length} campos)`);
  }
  return out;
}

export { extrairKpisDoPortalV26 };
export default extrairKpisDoPortalV26;
